import { SvgIcon } from '@material-ui/core'

export default (props) => (
  <SvgIcon {...props} viewBox='-1 -1 18 18'>
    <path d='M13.5,0h-11C1.122,0,0,1.122,0,2.5v8C0,11.879,1.122,13,2.5,13H3v2.5c0,0.202,0.122,0.385,0.309,0.462   C3.371,15.987,3.436,16,3.5,16c0.13,0,0.258-0.051,0.354-0.146L6.707,13H13.5c1.379,0,2.5-1.121,2.5-2.5v-8   C16,1.122,14.879,0,13.5,0z M15,10.5c0,0.827-0.673,1.5-1.5,1.5H6.293L4,14.293V12H2.5C1.673,12,1,11.327,1,10.5v-8   C1,1.673,1.673,1,2.5,1h11C14.327,1,15,1.673,15,2.5V10.5z' />
    <polygon points='7,7.586 4.707,5.293 3.293,6.707 7,10.414 12.707,4.707 11.293,3.293  ' />
  </SvgIcon>
)
